import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import styles from "./partner.module.css";
import Image1 from "../../../../../assests/partners_img/eh.jpeg";
import Image2 from "../../../../../assests/partners_img/grunberg.jpeg";
import Image3 from "../../../../../assests/partners_img/jfrag.png";
import Image4 from "../../../../../assests/partners_img/vegetablesLogo.PNG";
import Image5 from "../../../../../assests/partners_img/pure.jpeg";
import Image6 from "../../../../../assests/partners_img/sc1.png";
import Image7 from "../../../../../assests/partners_img/sc2.png";
import Image8 from "../../../../../assests/partners_img/ex_seba.png";
import Image9 from "../../../../../assests/partners_img/afbl.png";
import Image10 from "../../../../../assests/partners_img/bureWala.jpeg";

function Partner() {
  const pRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (pRef.current) {
      observer.observe(pRef.current);
    }

    return () => {
      if (pRef.current) {
        observer.unobserve(pRef.current);
      }
    };
  }, []);

  const Partner = [
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    Image7,
    Image8,
    Image9,
    Image10,
  ];
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    message: "",
  });

  const [responseMessage, setResponseMessage] = useState("");
  const formRef = useRef(null); // Reference to the form container
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (formRef.current) {
      observer.observe(formRef.current);
    }

    return () => {
      if (formRef.current) {
        observer.unobserve(formRef.current);
      }
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setResponseMessage("✅ Email sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          country: "",
          message: "",
        });

        setTimeout(() => {
          setResponseMessage("");
        }, 10000);
      }
    } catch (error) {
      setResponseMessage("❌ Network error, please try again later.");
      setTimeout(() => {
        setResponseMessage("");
      }, 5000);
    }
  };
  // Duplicate images for smooth infinite scrolling
  const images = [...Partner, ...Partner];

  const [index, setIndex] = useState(0);

  // Handle next image
  const goNext = () => {
    setIndex((prevIndex) => (prevIndex + 1) % Partner.length);
  };

  // Handle previous image
  const goPrevious = () => {
    setIndex((prevIndex) => (prevIndex - 1 + Partner.length) % Partner.length);
  };

  // Auto-scrolling effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % Partner.length);
    }, 3000); // Change image every 3s

    return () => clearInterval(interval);
  }, []);

  return (
    <div id="partner" className={styles.partner_wrapper}>
      <div className={styles.partner_container}>
        {/* Left Section: Partner Carousel */}
        <div className={styles.partnerLeft}>
          <h2
            ref={pRef}
            className={`${styles.partnerTitle} ${
              isVisible ? styles.show : ""
            }`}>
            Our Partners
          </h2>
          <p
            ref={pRef}
            className={`${styles.partnerSubtitle} ${
              isVisible ? styles.show : ""
            }`}>
            We Collaborate Only With The Best
          </p>

          <div className={styles.caroussel}>
            <div
              className={styles.imgContainer}
              style={{ transform: `translateX(-${index * 200}px)` }} // Dynamic shifting
            >
              {images.map((img, i) => (
                <div key={i} className={styles.imgWrapper}>
                  <img src={img} alt={`partner-${i}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Section: Inquiry */}
        <div className={styles.partnerRight}>
          <h2
            ref={pRef}
            className={`${styles.rightH2} ${isVisible ? styles.show : ""}`}>
            Have a Question?
          </h2>
          <p
            ref={pRef}
            className={`${styles.rightP} ${isVisible ? styles.show : ""}`}>
            Our Consultants Will Always Be Glad To Help
          </p>
          <form onSubmit={handleSubmit} className={styles.form_container}>
            <div className={styles.form_group_partition}>
              <div className={styles.form_group}>
                <label htmlFor="name">Name: </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.form_group}>
                <label htmlFor="email">Email: </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className={styles.form_group_partition}>
              <div className={styles.form_group}>
                <label htmlFor="phone">Phone Number:</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                  placeholder="123-456-7890"
                />
              </div>
              <div className={styles.form_group}>
                <label htmlFor="country">Country Name:</label>
                <input
                  type="text"
                  id="country"
                  name="country"
                  placeholder="Enter Your Country"
                  value={formData.country}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className={styles.form_group}>
              <label htmlFor="message">Message: </label>
              <textarea
                id="message"
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required></textarea>
            </div>
            {responseMessage && <p>{responseMessage}</p>}
            <button type="submit" className={styles.submit_button}>
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Partner;
